import axios from "../../plugins/axios";
import utils from "../../../utils/utils2.js"; //避免与utils交叉引用


// 组织模块
class Org {
    //-----------------------------------集团-------------------------------------//
    // INTF-00022 不分页查询集团
    async getAllGroup() {
        let body = {};
        try {
            let res = await axios.post(`/myOrganizationApp/service.group.GroupProvider/FindAllWithoutLimit`, body)
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.group_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get all group with no pages failed: INTF-00022", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00026 分页查询集团
    async getAllGroupByPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myOrganizationApp/service.group.GroupProvider/FindAll`, body)
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.group_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get group list in pages failed: INTF-00026", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00027 创建一个集团
    addGroupOne(body) {
        return axios.post(`/myOrganizationApp/service.group.GroupProvider/CreateOne`, body)
    }

    // INTF-00028 编辑一个集团
    editGroupOne(body) {
        return axios.post(`/myOrganizationApp/service.group.GroupProvider/UpdateDetails`, body)
    }

    // INTF-00170 批量禁用或启用集团
    disOrEnableGroup(body) {
        return axios.post(`/myOrganizationApp/service.group.GroupProvider/UpdateActived`, body)
    }

    // INTF-00183 批量删除草稿状态的集团
    delDraftGroup(body) {
        return axios.post(`/myOrganizationApp/service.group.GroupProvider/Delete`, body)
    }

    // INTF-00173 获取一个集团下的下属公司
    async getFirmOfGroup(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myOrganizationApp/service.group.GroupProvider/ShowCompanys`, body)
            if (utils.isEmptyObject(res)) {
                //空对象，补全属性
                res.company_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get company list in group failed: INTF-00173", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00175 为一个集团增加多个下属公司
    addFirmOfGroup(group_id, company_ids) {
        let body = { group_id: group_id, company_id: company_ids };
        return axios.post(`/myOrganizationApp/service.group.GroupProvider/IncreaseCompany`, body)
    }

    // INTF-00179 为一个集团移除下属公司
    removeFirmOfGroup(group_id, company_ids) {
        let body = { group_id: group_id, company_id: company_ids };
        return axios.post(`/myOrganizationApp/service.group.GroupProvider/DecreaseCompany`, body)
    }

    //----------------------------------------------公司----------------------------------------------//
    // INTF-00144 不分页查询公司
    async getAllFirm() {
        let body = {};
        try {
            let res = await axios.post(`/myOrganizationApp/service.company.CompanyProvider/FindAllWithoutLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.company_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get company list no pages failed: INTF-00144", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00146 分页查询公司
    async getAllFirmByPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myOrganizationApp/service.company.CompanyProvider/FindAll`, body)
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.company_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get company list in pages failed: INTF-00146", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00174 分页查询没有所属关系的公司
    async getAllFirmNoGroup(body) {
        try {
            let res = await axios.post(`/myOrganizationApp/service.group.GroupProvider/OutOfTheGroup`, body)
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.company_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get company list not in group failed: INTF-00174", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00193 查询一个公司的详情，包含上下级信息
    async getOneFirmDetail(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myOrganizationApp/service.company.CompanyProvider/FindOne`, body)
            if (res.factory_infos === undefined) {
                //没有工厂列表信息，补全
                res.factory_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get company info failed: INTF-00193", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00140 创建一个公司
    addFirmOne(body) {
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/CreateOne`, body)
    }

    // INTF-00142 编辑一个公司
    editFirmOne(body) {
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/UpdateDetails`, body)
    }

    // INTF-00171 批量禁用或启用公司
    disOrEnableFirm(body) {
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/UpdateActived`, body)
    }

    // INTF-00181 批量删除草稿状态的公司
    delDraftFirm(body) {
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/Delete`, body)
    }

    // INTF-00178 为一个公司增加多个下属工厂
    addFactoryOfFirm(company_id, factory_ids) {
        let body = { company_id: company_id, factory_id: factory_ids };
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/IncreaseFactory`, body)
    }

    // INTF-00180 为一个公司移除下属工厂
    removeFactoryOfFirm(company_id, factory_ids) {
        let body = { company_id: company_id, factory_id: factory_ids };
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/DecreaseFactory`, body)
    }


    /*INTF-00753：在一个公司下，新增业务偏好的设置内容
    createBusinessPrefrenceByCompany(comId, settings) {
        //TBD：待接口完善
        let body = { companyId: comId, settings: settings };
        return axios.post(`/xxl`, body);
    }
    */

    //INTF-00754：修改一个公司下的业务偏好的设置内容
    updateBusinessPrefrenceByCompany(val) {
        let body = val;
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/UpdatePreference`, body);
    }


    //INTF-00759：查询一个公司下的业务偏好的设置内容
    async getBusinessPrefrenceByCompany(comId) {
        let body = { id: comId };
        try {
            let res = await axios.post(`/myOrganizationApp/service.company.CompanyProvider/GetPreference`, body);
            return res;
        } catch (err) {
            //判断err的信息中，是否有not found字符串
            let str = "not found";
            if (err.response.data.includes(str)) {
                //包含
                return {};
            } else {
                //没包含，确实是错误
                console.log("get business prefrence by company id failed: INTF-00759", err);
                return { err: true, msg: err.response.data };
            }
        }
    }

    //INTF-00762：获取一个公司下，跨公司交易的对手公司列表，不分页
    async getCrossTradeCompanyListByCompanyId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myOrganizationApp/service.company.CompanyProvider/GetInternalTrade`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.internal_trade_company_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get internal trade company list failed: INTF-00762", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00769：对新建的一个跨公司交易的对手公司进行保存
    addCrossTradeCompany(val) {
        let body = val;
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/AddInternalTrade`, body);
    }

    //INTF-00770：修改一个公司下的一条跨公司交易的对手公司信息
    updateCrossTradeCompany(val) {
        let body = val;
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/UpdateInternalTrade`, body);
    }

    //INTF-00771：删除选中的跨公司交易的对搜狐公司
    batchDeleteCrossTradeCompanies(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/DeleteInternalTrade`, body);
    }

    //INTF-00772：批量生失效跨公司交易的对手公司
    batchEnableOrDisableCrossTradeCompanies(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myOrganizationApp/service.company.CompanyProvider/UpdateInternalTradeActived`, body);
    }

    //INTF-00794：根据客户ID，获取该客户对应的集团公司的信息
    getCompanyInfoByCustomerId(id) {
        let body = { id: id };
        return axios.post(`/xxl`, body);
    }

    //INTF-00795：根据公司ID，获取该公司作为供应商的信息
    getSupplierInfoByCompanyId(id) {
        let body = { id: id };
        return axios.post(`/xxl`, body);
    }


    //------------------------------------------------工厂---------------------------------------------------//
    //INTF-00145：不分页的获取集团下所有的可用的工厂信息
    async getAllFactoriesInGroup() {
        let body = {};
        try {
            let res = await axios.post(`/myOrganizationApp/service.factory.FactoryProvider/FindAllWithoutLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全信息
                res.factory_infos = [];
                res.total = 0;
            }
            //把factory_infos中的name改成factory_name
            res.factory_infos.forEach((item) => {
                item.factory_name = item.name;
            });
            return res;
        } catch (err) {
            console.log("get all factories failed: INTF-00145", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00147 分页查询工厂
    async getAllFactoryByPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myOrganizationApp/service.factory.FactoryProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.factory_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get factory list in pages failed: INTF-00147", err);
            return { err: true, msg: err.respone.data };
        }
    }

    // INTF-00177 分页查询没有所属关系的工厂
    async getAllFactoryNoFirm(query) {
        let body = query;
        try {
            let res = await axios.post(`/myOrganizationApp/service.company.CompanyProvider/OutOfTheCompany`, body)
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.factory_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get factory list not in company failed: INTF-00177", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00197 查询一个工厂的详情，包含上下级信息
    async getOneFactoryDetail(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myOrganizationApp/service.factory.FactoryProvider/FindOne`, body)
            //检查warehouse_infos是否空的
            if (res.warehouse_infos === undefined) {
                //未定义，补全属性
                res.warehouse_infos = [];
            }
            return res;
        } catch (err) {
            console.log("get factory detail info failed: INTF-00197", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00141 创建一个工厂
    addFactoryOne(body) {
        return axios.post(`/myOrganizationApp/service.factory.FactoryProvider/CreateOne`, body)
    }

    // INTF-00143 编辑一个工厂
    editFactoryOne(body) {
        return axios.post(`/myOrganizationApp/service.factory.FactoryProvider/UpdateDetails`, body)
    }

    // INTF-00172 批量禁用或启用工厂
    disOrEnableFactory(body) {
        return axios.post(`/myOrganizationApp/service.factory.FactoryProvider/UpdateActived`, body)
    }

    // INTF-00182 批量删除草稿状态的工厂
    delDraftFactory(body) {
        return axios.post(`/myOrganizationApp/service.factory.FactoryProvider/Delete`, body)
    }

    // INTF-00215 为一个工厂添加下属库位
    addWhOfFactory(body) {
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/IncreaseFactory`, body)
    }

    // INTF-00217 为一个工厂移除下属库位
    removeWhOfFactory(body) {
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/RemoveFactory`, body)
    }


    //-----------------------收货人及地址相关信息--------------------------------------//

    //------------------------收获地址相关-------------------------------//
    //INTF-00400：获取不分页的收货地址列表
    async getAddressListWithNoLimit() {
        let body = {};
        try {
            let res = await axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/FindAllWithoutLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.receive_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get address list in no pages failed: INTF-00400", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00403：对新建的地址信息进行保存
    addNewAddress(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/CreateOne`, body);
    }

    //INTF-00405：获取分页的收货地址列表
    async getAddressList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.receive_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get receive address list in pages failed: INTF-00405", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00406：批量删除选中的收货地址
    batchDeleteAddress(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/Delete`, body);
    }

    //INTF-00407：对修改的收货地址进行保存
    updateAddress(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/UpdateDetails`, body);
    }

    //INTF-00411：批量设置收货地址的生失效
    batchEnableOrDisableAddress(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/UpdateActived`, body);
    }
    //------------------收货人及收货地址关系相关-------------------------//

    //INTF-00399：在一个收货地址下，移除收货人
    batchRemoveReceiverByAddress(id, arr) {
        let body = { receive_info_id: id, user_ids: arr };
        return axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/RemoveUsers`, body);
    }

    //INTF-00402：根据收货地址ID，获取不分页的收货人列表
    async getReceiverListByAddressId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/FindUsers`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.users = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get receiver list by receive address id failed: INTF-00402", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00404：在收货地址下添加收货人
    addNewReceiverInAddress(id, arr) {
        let body = { receive_info_id: id, user_ids: arr };
        return axios.post(`/myBasicDataApp/service.receive_info.ReceiveInfoProvider/AddUsers`, body);
    }


    //-------------------------用户自定义收货人相关-----------------------//
    //INTF-00577：分页查询获取收货人信息
    async getCustomizedReceiverListByPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBasicDataApp/service.receive_user.ReceiveUserProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.receive_user_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get customized receiver list by pages failed:INTF-00577", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00578：对新建的客户定义收货人进行保存
    addCustomizedReceiver(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.receive_user.ReceiveUserProvider/CreateOne`, body);
    }

    //INTF-00579：修改保存的客户定义收货人
    updateCustomizedReceiver(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.receive_user.ReceiveUserProvider/UpdateDetails`, body);
    }

    //INTF-00580：批量删除选中的收货人
    batchDeleteCustomizedReceivers(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myBasicDataApp/service.receive_user.ReceiveUserProvider/Delete`, body);
    }

    //INTF-00581：对选中的自定义收货人进行生失效标志
    batchEnableOrDisableCustomizedReceivers(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myBasicDataApp/service.receive_user.ReceiveUserProvider/UpdateActived`, body);
    }

    //---------------------收货方维护相关---------------------------------//
    //INTF-00704：分页获取收货方列表
    getReceiveCompanyListByPage(query, route) {
        let body = { types: "object,object", values: [query, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00705：对新建的收货方进行保存
    addReceiveCompany(val, route) {
        let body = { types: "object,object", values: [val, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00706：对修改的收货方进行保存
    updateReceiveCompany(val, route) {
        let body = { types: "object,object", values: [val, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00707：批量删除草稿的收货方列表
    batchDeleteReceiveCompany(arr, route) {
        let body = { types: "object,object", values: [{ id: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }



}


export default Org;